import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
    Box, Typography, RadioGroup, FormControlLabel, Radio, TextField, Button,
    Card, CardContent, IconButton, Divider, MenuItem, CircularProgress,
    ThemeProvider, createTheme, Avatar, Chip, FormControl, InputLabel, Select
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useNavigate } from "react-router-dom";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import styled from '@emotion/styled';

import DashboardService from "../dashboard.service";
import AuthService from "../../Authentication/auth.service";
import Alerts from "../../../components/Alerts/alerts";
import AlertService from '../../../components/Alerts/alerts';


const theme = createTheme({
    palette: {
        primary: {
            main: '#ff4757',
        },
        background: {
            default: '#f8f9fa',
        },
    },
    typography: {
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        h5: {
            fontWeight: 700,
        },
        subtitle1: {
            fontWeight: 600,
        },
        subtitle2: {
            fontWeight: 500,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                },
            },
        },
    },
});

const StyledRadio = styled(Radio)(({ theme }) => ({
    '&.Mui-checked': {
        color: theme.palette.error.main,
    },
}));

const TipButton = styled(Button)(({ theme }) => ({
    minWidth: 0,
    padding: theme.spacing(0.5, 2),
    borderRadius: 20,
}));

// Styled component for the overlay
const LoaderOverlay = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
`;



const CartView = () => {
    const [Prioritize, setPrioritize] = useState([]);
    const [cartData, setCartData] = useState([]);
    const [DistanceFormula, setDistanceFormula] = useState(0);
    const [addressesList, setAddressesList] = useState([]);
    const [userDetails, setUserDetails] = useState(null);
    const [userBalance, setUserBalance] = useState(null);
    const [calculations, setCalculations] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deliveryMethod, setDeliveryMethod] = useState('delivery');
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [priorityTip, setPriorityTip] = useState(0);
    const [couponCode, setCouponCode] = useState('');
    const navigate = useNavigate();

    const [deliveryMethods, setDeliveryMethods] = useState([]);
    const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState('');


    useEffect(() => {
        fetchCartData();
    }, []);

    const fetchCartData = async () => {
        try {
            setLoading(true);
            let status = false;
            if(deliveryMethod !== 'delivery'){
                status= true
            }
            const userString = localStorage.getItem('user');
            const user = JSON.parse(userString);
            const userId = user['_id'];
            const updateData = {
                "functionName": "GetCartList",
                "postData": {
                    "user_id": userId,
                    "filters": {
                        "status": false,
                        "coupan_code": '',
                        "prioritize": "",
                        "DeliveryMethod":'',
                        "address_id": '',
                        "self_pickup": status,
                        "quantity": {
                            "cart_id": '',
                            "quantity": ''
                        }
                    }

                }
            };
            DashboardService.GetCartList(updateData).then((response) => {
                setLoading(false); // Set loading state to false after data retrieval
                // Handle response data
                console.log("cart Data", response.data);
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (response.data) {
                        setPrioritize(response.data.Prioritizes);
                        setCartData(response.data.cartData);
                        setDeliveryMethods(response.data.DeliveryMethods);
                        if (response.data.DeliveryMethods.length > 0 && !selectedDeliveryMethod) {
                            setSelectedDeliveryMethod(response.data.DeliveryMethods[0]._id);
                        }        
                        setDistanceFormula(response.data.DistanceFormula);
                        setAddressesList(response.data.AddressessList);
                        setUserDetails(response.data.UserDetails?.[0]);
                        setUserBalance(response.data.UserBalance?.[0]);
                        setCalculations(response.data.Calculations);
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    };

    const handleDeliveryMethodChange = (event) => {
        setSelectedDeliveryMethod(event.target.value);
        try {
            setLoading(true);
            let status = false;
            if(deliveryMethod !== 'delivery'){
                status= true
            }
            const updateData = {
                "functionName": "GetCartList",
                "postData": {
                    "user_id": userDetails?._id,
                    "filters": {
                        "status": true,
                        "coupan_code": couponCode,
                        "DeliveryMethod":event.target.value,
                        "address_id": deliveryAddress,
                        "self_pickup": status,
                        "prioritize": priorityTip,
                        "quantity": {
                            "cart_id": '',
                            "quantity": ''
                        }
                    }
                }
            };
            console.log("updateData", updateData);
            DashboardService.GetCartList(updateData).then((response) => {
                setLoading(false); // Set loading state to false after data retrieval
                // Handle response data
                console.log("cart Data", response.data);
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (response.data) {
                        console.log("my updated Item cart Data", response.data);
                        // setBranches(response.data.data); // Set total rows based on response length
                        setCartData(response.data.cartData);
                        setPrioritize(response.data.Prioritizes);
                        setDistanceFormula(response.data.DistanceFormula);
                        setAddressesList(response.data.AddressessList);
                        setUserDetails(response.data.UserDetails?.[0]);
                        setUserBalance(response.data.UserBalance?.[0]);
                        setCalculations(response.data.Calculations);
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
        };


    const handleUpdateQuantity = (productId, newQuantity) => {
        setCartData(prevItems =>
            prevItems.map(item =>
                item._id === productId ? { ...item, quantity: Math.max(1, newQuantity).toString() } : item
            )
        );
    };


    const handleApplyCoupon = async () => {
        setLoading(true);
        console.log('Applying coupon:', couponCode);
        let status = false;
            if(deliveryMethod !== 'delivery'){
                status= true
            }
        try {
            const updateData = {
                "functionName": "GetCartList",
                "postData": {
                    "user_id": userDetails?._id,
                    "filters": {
                        "status": true,
                        "coupan_code": couponCode,
                        "DeliveryMethod":selectedDeliveryMethod,
                        "address_id": deliveryAddress,
                        "self_pickup": status,
                        "prioritize": priorityTip,
                        "quantity": {
                            "cart_id": '',
                            "quantity": ''
                        }
                    }

                }
            };
            console.log("updateData", updateData);
            DashboardService.GetCartList(updateData).then((response) => {
                setLoading(false);
                // Handle response data
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if(response.data.filter_message)
                    {
                        Alerts.swalInfoAlert(response.data.filter_message);
                    }
                    if (response.data) {
                        console.log("my cart Data", response.data.cartData);
                        setCartData(response.data.cartData);
                        setPrioritize(response.data.Prioritizes);
                        setDistanceFormula(response.data.DistanceFormula);
                        setAddressesList(response.data.AddressessList);
                        setUserDetails(response.data.UserDetails?.[0]);
                        setUserBalance(response.data.UserBalance?.[0]);
                        setCalculations(response.data.Calculations);
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    };

    const handleTip = async (TIP) => {
        console.log('Applying TIP:', TIP);
        setCouponCode()
        try {
            setLoading(true);
            let status = false;
            if(deliveryMethod !== 'delivery'){
                status= true
            }
            const updateData = {
                "functionName": "GetCartList",
                "postData": {
                    "user_id": userDetails?._id,
                    "filters": {
                        "status": true,
                        "coupan_code": couponCode,
                        "DeliveryMethod":selectedDeliveryMethod,
                        "address_id": deliveryAddress,
                        "self_pickup": status,
                        "prioritize": TIP,
                        "quantity": {
                            "cart_id": '',
                            "quantity": ''
                        }
                    }
                }
            };
            console.log("updateData", updateData);
            DashboardService.GetCartList(updateData).then((response) => {
                setLoading(false); // Set loading state to false after data retrieval
                // Handle response data
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (response.data) {
                        setCartData(response.data.cartData);
                        setPrioritize(response.data.Prioritizes);
                        setDistanceFormula(response.data.DistanceFormula);
                        setAddressesList(response.data.AddressessList);
                        setUserDetails(response.data.UserDetails?.[0]);
                        setUserBalance(response.data.UserBalance?.[0]);
                        setCalculations(response.data.Calculations);
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    };

    const handleUpdateItem = async (item) => {
        console.log('Applying update item:', item);
        try {
            setLoading(true);
            let status = false;
            if(deliveryMethod !== 'delivery'){
                status= true
            }
            const updateData = {
                "functionName": "GetCartList",
                "postData": {
                    "user_id": userDetails?._id,
                    "filters": {
                        "status": true,
                        "coupan_code": couponCode,
                        "DeliveryMethod":selectedDeliveryMethod,
                        "address_id": deliveryAddress,
                        "self_pickup": status,
                        "prioritize": priorityTip,
                        "quantity": {
                            "cart_id": item._id,
                            "quantity": item.quantity
                        }
                    }
                }
            };
            DashboardService.GetCartList(updateData).then((response) => {
                setLoading(false); // Set loading state to false after data retrieval
                // Handle response data
                console.log("cart Data", response.data);
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (response.data) {
                        console.log("my updated Item cart Data", response.data.cartData);
                        // setBranches(response.data.data); // Set total rows based on response length
                        setCartData(response.data.cartData);
                        setPrioritize(response.data.Prioritizes);
                        setDistanceFormula(response.data.DistanceFormula);
                        setAddressesList(response.data.AddressessList);
                        setUserDetails(response.data.UserDetails?.[0]);
                        setUserBalance(response.data.UserBalance?.[0]);
                        setCalculations(response.data.Calculations);
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    };

    const handleRemoveItem = async (item) => {
        console.log('Applying Remove item:', item);
        try {
            setLoading(true);
            let status = false;
            if(deliveryMethod !== 'delivery'){
                status= true
            }
            const updateData = {
                "functionName": "GetCartList",
                "postData": {
                    "user_id": userDetails?._id,
                    "filters": {
                        "status": true,
                        "coupan_code": couponCode,
                        "DeliveryMethod":selectedDeliveryMethod,
                        "address_id": deliveryAddress,
                        "self_pickup": status,
                        "prioritize": priorityTip,
                        "quantity": {
                            "cart_id": item._id,
                            "quantity": ''
                        }
                    }
                   

                }
            };
            console.log("updateData", updateData);
            DashboardService.GetCartList(updateData).then((response) => {
                setLoading(false); // Set loading state to false after data retrieval
                // Handle response data
                console.log("cart Data", response.data);
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (response.data) {
                        console.log("my updated Item cart Data", response.data.cartData);
                        // setBranches(response.data.data); // Set total rows based on response length
                        setCartData(response.data.cartData);
                        setPrioritize(response.data.Prioritizes);
                        setDistanceFormula(response.data.DistanceFormula);
                        setAddressesList(response.data.AddressessList);
                        setUserDetails(response.data.UserDetails?.[0]);
                        setUserBalance(response.data.UserBalance?.[0]);
                        setCalculations(response.data.Calculations);
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    };

    const handleAddress = async (Address) => {
        try {
            setLoading(true);
            let status = false;
            if(deliveryMethod !== 'delivery'){
                status= true
            }
            const updateData = {
                "functionName": "GetCartList",
                "postData": {
                    "user_id": userDetails?._id,
                    "filters": {
                        "status": true,
                        "coupan_code": couponCode,
                        "DeliveryMethod":selectedDeliveryMethod,
                        "address_id": Address,
                        "self_pickup": status,
                        "prioritize": priorityTip,
                        "quantity": {
                            "cart_id": '',
                            "quantity": ''
                        }
                    }
                }
            };
            console.log("updateData", updateData);
            DashboardService.GetCartList(updateData).then((response) => {
                setLoading(false); // Set loading state to false after data retrieval
                // Handle response data
                console.log("cart Data", response.data);
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (response.data) {
                        console.log("my updated Item cart Data", response.data);
                        // setBranches(response.data.data); // Set total rows based on response length
                        setCartData(response.data.cartData);
                        setPrioritize(response.data.Prioritizes);
                        setDistanceFormula(response.data.DistanceFormula);
                        setAddressesList(response.data.AddressessList);
                        setUserDetails(response.data.UserDetails?.[0]);
                        setUserBalance(response.data.UserBalance?.[0]);
                        setCalculations(response.data.Calculations);
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    };

    const handlePickup = async (pickupMethod) => {
        console.log('Applying Self_Pickup:', pickupMethod);
        let status = false;
        if (pickupMethod === 'selfPickUp') {
            status = true;
        }
        try {
            if(status===true)
            {

            
            setLoading(true);

            const updateData = {
                "functionName": "GetCartList",
                "postData": {
                    "user_id": userDetails?._id,
                    "filters": {
                        "status": true,
                        "coupan_code": "",
                        "delivery_method": "",
                        "prioritize": "",
                        "self_pickup": status,
                        "DeliveryMethod":'',
                        "address_id": '',
                        "quantity": {
                            "cart_id": '',
                            "quantity": ''
                        }
                    }

                }
            };
            console.log("updateData", updateData);
            DashboardService.GetCartList(updateData).then((response) => {
                setLoading(false); // Set loading state to false after data retrieval
                // Handle response data
                console.log("cart Data", response.data);
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (response.data) {
                        console.log("my updated Item cart Data", response.data.cartData);
                        // setBranches(response.data.data); // Set total rows based on response length
                        setCartData(response.data.cartData);
                        setPrioritize(response.data.Prioritizes);
                        setDistanceFormula(response.data.DistanceFormula);
                        setAddressesList(response.data.AddressessList);
                        setUserDetails(response.data.UserDetails?.[0]);
                        setUserBalance(response.data.UserBalance?.[0]);
                        setCalculations(response.data.Calculations);
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
            }else{
                fetchCartData();
            }
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    }


    const HandleCartEmpty = async () => {
        try {
            setLoading(true);
            const userString = localStorage.getItem('user');
            const user = JSON.parse(userString);
            const userId = user['_id'];

            const updateData = {
                "functionName": "DeleteCart",
                "postData": {
                    "user_id": userId,
                    "cart_id": ""
                }
            };
            console.log("DeleteCart", updateData);
            DashboardService.DeleteCart(updateData).then((response) => {
                setLoading(false); // Set loading state to false after data retrieval
                // Handle response data
                console.log("cart Data", response.data);
                if (response.data.message === "Unauthorized") {
                    // Perform logout and redirection for unauthorized access
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (response.data) {
                        Alerts.swalClickProceedAlert(response.data.message).then(res => {
                            if (res === true) {
                                fetchCartData();
                            }
                        });  
                    }
                }
            },
                (error) => {
                    setLoading(false); // Set loading state to false in case of error
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent)
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent)
                    }
                    else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.")
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    };


    const HandlePlaceOrder = async (cartData, deliveryMethod, deliveryAddress, priorityTip, couponCode, total) => {
        console.log('cartData----->',cartData);
        try {
            let Cart = []
            cartData.map((cartItem) => {
                Cart.push({
                    _id: cartItem._id,
                    quantity: cartItem.quantity,
                    price: cartItem.price,
                    total_price: cartItem.total_price,
                    category_id: cartItem.category_details._id,
                    business_id: cartItem.business_details._id,
                    product_id: cartItem.product_details._id,
                    variations : cartItem.variations,
                    is_reviewed: 0,
                })
            })
            const userString = localStorage.getItem('user');
            const user = JSON.parse(userString);
            const userId = user['_id'];
            let Addresses = [];
            if (deliveryMethod !== 'selfPickUp') {
                Addresses = addressesList.filter(address =>
                    address._id === deliveryAddress
                );
            }

            let pay_topup = false;
            console.log("userBalance?.total_balance",userBalance?.total_balance);
            if(userBalance?.total_balance > total ){
                let userRemainingBalance = userBalance?.total_balance - total
                if(userRemainingBalance >= 0){
                console.log("Pay From Topup");
                pay_topup =true;
                }
            }

            setLoading(true);
            var getData = {
                functionName: "placeOrder",
                "postData": {
                    user_id: userId,
                    pay_topup:pay_topup,
                    cartData: Cart,
                    deliveryMethod,
                    Addresses,
                    priorityTip,
                    couponCode,
                    total: parseFloat(total).toFixed(2),
                    DistanceFormula: DistanceFormula,
                    Calculations: calculations
                }
            }
            console.log("getData", getData);
            setLoading(true);
            DashboardService.PlaceOrder(getData).then((response) => {
                console.log(response);
                setLoading(false);
                if (response.status === 200) {
                    console.log(response);
                    if(pay_topup){

                    }else{
                        window.open(response.data.data, '_blank');   
                        window.location.reload();                     
                    }
                    AlertService.successToast("Order Placed Now Pay to Proceed.")
                    fetchCartData();
                } else if (response.status === 401) {
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                } else {
                    window.open(response.data.data, '_blank');
                }
            },
                (error) => {
                    setLoading(false);
                    const errContent =
                        (error.response && error.response.data) || error.message || error.toString();
                    console.log("Net:-", errContent);
                    if (errContent) {
                        Alerts.swalErrorAlert(errContent);
                    } else {
                        Alerts.swalErrorAlert("Server Error, Please try again later.");
                    }
                })
        } catch (err) {
            // setError('Failed to fetch cart data. Please try again.');
            console.error('Error fetching cart data:', err);
        } finally {
            // setLoading(false);
        }
    };


    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ maxWidth: 600, margin: 'auto', padding: 3, backgroundColor: theme.palette.background.default, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                {loading && (
                    <LoaderOverlay>
                        <CircularProgress />
                    </LoaderOverlay>
                )}
                {error ? (
                    <Box display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
                        <Typography color="error">{error}</Typography>
                    </Box>
                ) : cartData && cartData.length > 0 ? (
                    <>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h5">Your Cart</Typography>
                            <Button onClick={() => { HandleCartEmpty() }} startIcon={<ShoppingCartIcon />} color="inherit" variant="outlined" size="small">
                                Empty Cart
                            </Button>
                        </Box>
                        <Card sx={{ mb: 3 }}>
                            <CardContent>
                                <RadioGroup
                                    value={deliveryMethod}
                                    onChange={(e) => {
                                        setDeliveryMethod(e.target.value)
                                        handlePickup(e.target.value);
                                    }}
                                    row
                                >
                                        <FormControlLabel value="delivery" control={<StyledRadio />} label="Delivery" />
                                    <FormControlLabel value="selfPickUp" control={<StyledRadio />} label="Self Pick Up" />
                                </RadioGroup>

                                {deliveryMethod === 'delivery' && (
                                    <Box mt={2}>
                                        <Typography variant="subtitle2" mb={1}>Delivery Method</Typography>
                                        {deliveryMethods.length === 0 ? 
                                        <Typography color='red' variant="subtitle2" mb={1}>No Delivery Method available right now Please choose self pickup</Typography>
                                        :
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <InputLabel id="delivery-method-label">Delivery Method</InputLabel>
                                                <Select
                                                    labelId="delivery-method-label"
                                                    id="delivery-method-select"
                                                    value={selectedDeliveryMethod}
                                                    label="Delivery Method"
                                                    onChange={handleDeliveryMethodChange}
                                                >
                                                    {deliveryMethods.map((method) => (
                                                        <MenuItem key={method._id} value={method._id}>
                                                            {method.method}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        }
                                        <Typography variant="subtitle2" mb={1}>Delivery To</Typography>
                                          <Select
                                            fullWidth
                                            value={deliveryAddress || ''}
                                            onChange={(e) => {
                                                console.log(e.target.value);
                                                setDeliveryAddress(e.target.value);
                                                handleAddress(e.target.value);
                                            }}
                                            displayEmpty
                                            size="small"
                                            sx={{ backgroundColor: 'white' }}
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return <em>Select an address</em>;
                                                }
                                                const selectedAddress = addressesList.find(address => address._id === selected);
                                                return selectedAddress ? selectedAddress.label : '';
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                <em>Select an address</em>
                                            </MenuItem>
                                            {addressesList && addressesList.map((address) => (
                                                <MenuItem key={address._id} value={address._id}>
                                                    {address.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <>
                                            <Box display="flex" alignItems="center" mb={1}>
                                                <LocationOnIcon color="error" fontSize="small" sx={{ mr: 1 }} />
                                                {addressesList && addressesList?.map((address) => (
                                                    address._id === deliveryAddress &&
                                                    <Typography variant="body2">{`${address?.location}, ${address?.block}, ${address?.unit}`}</Typography>
                                                ))}
                                            </Box>
                                            <Box display="flex" alignItems="center">
                                                <DirectionsBikeIcon color="error" fontSize="small" sx={{ mr: 1 }} />
                                                {DistanceFormula.length > 0 &&
                                                    <Typography variant="body2">
                                                        Distance from you: {DistanceFormula?.distance?.value ?
                                                            `${parseFloat(DistanceFormula?.distance?.value).toFixed(2) / 1000}km (${parseFloat(calculations?.deliveryTipFee).toFixed(2)})` : ''}
                                                   </Typography>
                                                }
                                            </Box>
                                            <Typography variant="caption" color="text.secondary">
                                                incl. priority fee
                                            </Typography>
                                        </>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                        {deliveryMethod === 'delivery' && deliveryAddress !=='' &&
                            <Card sx={{ mb: 3 }}>
                                <CardContent>
                                    <Typography variant="subtitle2" mb={1}>Prioritize Your Delivery</Typography>
                                    <Typography variant="caption" color="text.secondary" display="block" mb={2}>
                                        *Tip helps to prioritize your delivery
                                    </Typography>
                                    <Box display="flex" justifyContent="space-between">
                                        {Prioritize.map((tip) => (
                                            <TipButton
                                                key={tip}
                                                variant={priorityTip === tip ? "contained" : "outlined"}
                                                onClick={(e) => {
                                                handleTip(priorityTip === tip ? 0 : tip);
                                                setPriorityTip(priorityTip === tip ? 0 : tip)
}                                                }
                                            >
                                                {parseFloat(tip).toFixed(2)}
                                            </TipButton>
                                        ))}
                                    </Box>
                                </CardContent>
                            </Card>
                        }

                        <Card sx={{ mb: 3 }}>
                            <CardContent>
                                <Typography variant="subtitle2" mb={1}>Discount Coupon</Typography>
                                <Box display="flex">
                                    <TextField
                                        fullWidth
                                        placeholder="Enter coupon code"
                                        value={couponCode}
                                        onChange={(e) => setCouponCode(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        sx={{ backgroundColor: 'white' }}
                                        InputProps={{
                                            startAdornment: <LocalOfferIcon color="action" sx={{ mr: 1 }} />,
                                        }}
                                    />
                                    <Button variant="contained" onClick={handleApplyCoupon} sx={{ ml: 1 }}>
                                        Apply
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>

                        <Card sx={{ mb: 3 }}>
                            <CardContent>
                                <Typography variant="subtitle1" mb={2}>Order Summary</Typography>
                                {cartData.map((item) => (
                                    <Box key={item._id} sx={{ mb: 3 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                            <Avatar src={item.product_details.Images[0]} sx={{ mr: 2 }} />
                                            <Box flexGrow={1}>
                                                <Typography variant="subtitle2">{item.product_details.item_name}</Typography>
                                                <Typography variant="body2" color="text.secondary">{parseFloat(item.price).toFixed(2)} X {item.quantity}</Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center">
                                                <IconButton onClick={() => handleUpdateQuantity(item._id, parseInt(item.quantity) - 1)} size="small">
                                                    <RemoveIcon fontSize="small" />
                                                </IconButton>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    onClick={() => handleUpdateItem(item)}
                                                    sx={{ mx: 1 }}
                                                >
                                                    Update {item.quantity}
                                                </Button>
                                                <IconButton onClick={() => handleUpdateQuantity(item._id, parseInt(item.quantity) + 1)} size="small">
                                                    <AddIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                            <IconButton onClick={() => handleRemoveItem(item)} size="small" sx={{ ml: 1 }}>
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        </Box>

                                        {item.variations && item.variations.length > 0 && (
                                            <Box sx={{ ml: 7, mt: 1 }}>
                                                <Typography variant="body2" color="text.secondary" gutterBottom>Variations:</Typography>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                    {item.variations.map((variation, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={`${variation.variation_name}: ${variation.variation_type_name} (${parseFloat(variation.variation_price).toFixed(2)} X ${item.quantity})`}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: theme.palette.primary.light,
                                                                color: theme.palette.primary.contrastText,
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                ))}

                                    

                                <Divider sx={{ my: 2 }} />
                                <Box>
                                    <Box display="flex" justifyContent="space-between" mb={1}>
                                        <Typography>Subtotal</Typography>
                                        <Typography>{parseFloat(calculations?.subTotal).toFixed(2)}</Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" mb={1}>
                                        <Typography>Discount</Typography>
                                        <Typography>-{parseFloat(calculations?.discount).toFixed(2)}</Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" mb={1}>
                                        <Typography>{calculations?.sst_dynamic_label ? `${calculations?.sst_dynamic_label}(${calculations?.sst_percentage})` : 'SST'}</Typography>
                                        <Typography>{parseFloat(calculations.sst).toFixed(2)}</Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" mb={1}>
                                        <Typography>Delivery Fee & Tip</Typography>
                                        <Typography>{parseFloat(calculations.deliveryTipFee).toFixed(2)}</Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" mt={2}>
                                        <Typography variant="subtitle1">Total</Typography>
                                        <Typography variant="subtitle1" color="primary">{parseFloat(calculations.grandTotal).toFixed(2)}</Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>

                        <Card sx={{ mb: 3 }}>
                            <CardContent>
                                <Typography variant="subtitle2" mb={1}>Reward Points</Typography>
                                <Box display="flex" alignItems="center">
                                    <CardGiftcardIcon sx={{ mr: 2 }} />
                                    <Typography >You will get <b style={{color:'red'}}>{calculations?.order_reward_points}</b> reward points.</Typography>
                                </Box>
                            </CardContent>
                        </Card>

                        <Card sx={{ mb: 3 }}>
                            <CardContent>
                                <Typography variant="subtitle2" mb={1}>Payment Method</Typography>
                                <Box display="flex" alignItems="center">
                                    <AccountBalanceWalletIcon sx={{ mr: 2 }} />
                                    <Typography>Balance: {userBalance?.total_balance ? parseFloat(userBalance?.total_balance).toFixed(2) : 0.00}</Typography>
                                </Box>
                            </CardContent>
                        </Card>

                        <Card sx={{ mb: 3 }}>
                            <CardContent>
                                <Typography variant="subtitle2" mb={1}>Branch</Typography>
                                <Box display="flex" alignItems="center">
                                    <StorefrontIcon sx={{ mr: 2 }} />
                                    <Typography>{cartData[0].business_details.name}</Typography>
                                </Box>
                            </CardContent>
                        </Card>

                        <Button
                            variant="contained"
                            fullWidth
                            size="large"
                            sx={{ py: 1.5, fontSize: '1.1rem' }}
                            onClick={() => {
                                HandlePlaceOrder(cartData, deliveryMethod, deliveryAddress, priorityTip, couponCode, calculations.grandTotal);
                                console.log("Place Order", { cartData, deliveryMethod, deliveryAddress, priorityTip, couponCode, total: calculations.grandTotal })
                            }}
                        >
                            Place Order
                        </Button>
                    </>
                ) : (
                    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" flexGrow={1}>
                        <Typography variant="h5" align="center" gutterBottom>Your Cart is Empty</Typography>
                        <Typography variant="body1" align="center">
                            Looks like you haven't added any items to your cart yet.
                        </Typography>
                        <Button
                            variant="contained"
                            fullWidth
                            size="large"
                            sx={{ mt: 3, py: 1.5, fontSize: '1.1rem', maxWidth: 300 }}
                            onClick={() => { navigate('/CustomerHome') }}
                        >
                            Start Shopping
                        </Button>
                    </Box>
                )}
            </Box>
        </ThemeProvider>
    );
};

export default CartView;


// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import {
//     Box, Typography, RadioGroup, FormControlLabel, Radio, TextField, Button,
//     Card, CardContent, IconButton, Divider, Select, MenuItem, CircularProgress,
//     ThemeProvider, createTheme, styled, Avatar
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@mui/icons-material/Remove';
// import CloseIcon from '@mui/icons-material/Close';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import StorefrontIcon from '@mui/icons-material/Storefront';
// import axios from 'axios';
// import { useNavigate } from "react-router-dom";
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
// import DashboardService from "../dashboard.service";
// import AuthService from "../../Authentication/auth.service";
// import Alerts from "../../../components/Alerts/alerts";
// import AlertService from '../../../components/Alerts/alerts';


// const theme = createTheme({
//     palette: {
//         primary: {
//             main: '#ff4757',
//         },
//         background: {
//             default: '#f8f9fa',
//         },
//     },
//     typography: {
//         fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
//         h5: {
//             fontWeight: 700,
//         },
//         subtitle1: {
//             fontWeight: 600,
//         },
//         subtitle2: {
//             fontWeight: 500,
//         },
//     },
//     components: {
//         MuiButton: {
//             styleOverrides: {
//                 root: {
//                     textTransform: 'none',
//                     borderRadius: 8,
//                 },
//             },
//         },
//         MuiCard: {
//             styleOverrides: {
//                 root: {
//                     borderRadius: 12,
//                     boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
//                 },
//             },
//         },
//     },
// });

// const StyledRadio = styled(Radio)(({ theme }) => ({
//     '&.Mui-checked': {
//         color: theme.palette.error.main,
//     },
// }));

// const TipButton = styled(Button)(({ theme }) => ({
//     minWidth: 0,
//     padding: theme.spacing(0.5, 2),
//     borderRadius: 20,
// }));

// const LoaderOverlay = styled(Box)(({ theme }) => ({
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(255, 255, 255, 0.7)',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     zIndex: 9999,
// }));


// const CartView = () => {
//     const [cartState, setCartState] = useState({
//         Prioritizes: [],
//         cartData: [],
//         DistanceFormula: 0,
//         AddressessList: [],
//         userDetails: null,
//         userBalance: null,
//         Calculations: {},
//     });
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [deliveryMethod, setDeliveryMethod] = useState('delivery');
//     const [deliveryAddress, setDeliveryAddress] = useState('');
//     const [priorityTip, setPriorityTip] = useState(0);
//     const [couponCode, setCouponCode] = useState('');
//     const navigate = useNavigate();

//     const fetchCartData = useCallback(async (filters = {}) => {
//         try {
//             setLoading(true);
//             const userString = localStorage.getItem('user');
//             const user = JSON.parse(userString);
//             const userId = user['_id'];
//             const updateData = {
//                 "functionName": "GetCartList",
//                 "postData": {
//                     "user_id": userId,
//                     "filters": {
//                         ...filters
//                     }
//                 }
//             };
//             const response = await DashboardService.GetCartList(updateData);
//             if (response.data.message === "Unauthorized") {
//                 AuthService.logout();
//                 navigate("/login");
//                 window.location.reload();
//             } else if (response.data) {
//                 console.log('Cart DATA :', response.data);
//                 setCartState(response.data);
//             }
//         } catch (err) {
//             setError('Failed to fetch cart data. Please try again.');
//             console.error('Error fetching cart data:', err);
//         } finally {
//             setLoading(false);
//         }
//     }, [navigate]);

//     useEffect(() => {
//         fetchCartData();
//     }, [fetchCartData]);

//     const handleUpdateQuantity = useCallback((productId, newQuantity) => {
//         setCartState(prevState => ({
//             ...prevState,
//             cartData: prevState.cartData.map(item =>
//                 item._id === productId ? { ...item, quantity: Math.max(1, newQuantity).toString() } : item
//             )
//         }));
//     }, []);

//     const handleApplyCoupon = useCallback(() => {
//         fetchCartData({
//             "status": true,
//             "coupan_code": couponCode,
//             "prioritize": priorityTip,
//             "self_pickup": false,
//             "address_id": deliveryAddress,
//             "quantity": {
//                 "cart_id": "",
//                 "quantity": ""
//             }
//         });
//     }, [couponCode]);

//     const handleTip = useCallback((tip) => {
//         fetchCartData({
//             "status": true,
//             "coupan_code": couponCode,
//             "prioritize": tip,
//             "self_pickup": false,
//             "address_id": deliveryAddress,
//             "quantity": {
//                 "cart_id": "",
//                 "quantity": ""
//             }
//         });
//         setPriorityTip(tip);
//     }, [fetchCartData]);

//     const handleUpdateItem = useCallback((item) => {
//         fetchCartData({
//             "status": true,
//             "coupan_code": couponCode,
//             "prioritize": priorityTip,
//             "self_pickup": false,
//             "address_id": deliveryAddress,
//             "quantity": {
//                 "cart_id": item._id,
//                 "quantity": item.quantity
//             }
//         });
//     }, [fetchCartData]);

//     const handleRemoveItem = useCallback((item) => {
//         fetchCartData({
//             "status": true,
//             "coupan_code": couponCode,
//             "prioritize": priorityTip,
//             "self_pickup": false,
//             "address_id": deliveryAddress,
//             "quantity": {
//                 "cart_id": item._id,
//                 "quantity": ''
//             }
//         });
//     }, [fetchCartData]);

//     const handleAddress = useCallback((address) => {
//         fetchCartData({
//             "status": true,
//             "coupan_code": couponCode,
//             "prioritize": priorityTip,
//             "self_pickup": false,
//             "address_id": address,
//             "quantity": {
//                 "cart_id": item._id,
//                 "quantity": item.quantity
//             }
//         });
        
//         setDeliveryAddress(address);
//     }, [fetchCartData]);

//     const handlePickup = useCallback((pickupMethod) => {
//         const status = pickupMethod !== 'delivery';
//         fetchCartData({
//             "status": true,
//             "coupan_code": couponCode,
//             "prioritize": '',
//             "self_pickup": status,
//             "address_id": address,
//             "quantity": {
//                 "cart_id": item._id,
//                 "quantity": item.quantity
//             }
//         });
//         fetchCartData({
//             "status": true,
//             "self_pickup": status
//         });
//         setDeliveryMethod(pickupMethod);
//     }, [fetchCartData]);

//     const handleCartEmpty = useCallback(async () => {
//         try {
//             setLoading(true);
//             const userString = localStorage.getItem('user');
//             const user = JSON.parse(userString);
//             const userId = user['_id'];
//             await DashboardService.DeleteCart({
//                 "functionName": "DeleteCart",
//                 "postData": {
//                     "user_id": userId,
//                     "cart_id": ""
//                 }
//             });
//             fetchCartData();
//         } catch (err) {
//             console.error('Error emptying cart:', err);
//             AlertService.swalErrorAlert("Failed to empty cart. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     }, [fetchCartData]);

//     const handlePlaceOrder = useCallback(async () => {
//         try {
//             setLoading(true);
//             const userString = localStorage.getItem('user');
//             const user = JSON.parse(userString);
//             const userId = user['_id'];
//             const cart = cartState.cartData.map(item => ({
//                 // _id: item._id,
//                 // product_name: item.item_name,
//                 quantity: item.quantity,
//                 price: item.price,
//                 total_price: item.total_price,
//                 category_id: item.category_details._id,
//                 business_id: item.business_details._id,
//                 product_id: item.product_details._id,
//             }));
//             let Addresses = [];
//             if (deliveryMethod !== 'selfPickUp') {
//                 Addresses = cartState.AddressessList.filter(address =>
//                     address._id === deliveryAddress
//                 );
//             }
//             const orderData = {
//                 functionName: "placeOrder",
//                 postData: {
//                     user_id: userId,
//                     cartData: cart,
//                     deliveryMethod,
//                     Addresses,
//                     priorityTip,
//                     couponCode,
//                     total: parseFloat(cartState.Calculations.grandTotal).toFixed(2),
//                     DistanceFormula: cartState.DistanceFormula,
//                     Calculations: cartState.Calculations
//                 }
//             };
//             const response = await DashboardService.PlaceOrder(orderData);
//             if (response.status === 200) {
//                 window.open(response.data.data, '_blank');
//                 AlertService.successToast("Order Placed Now Pay to Proceed.");
//                 // window.location.reload();
//             } else {
//                 window.open(response.data.data, '_blank');
//             }
//         } catch (err) {
//             console.error('Error placing order:', err);
//             AlertService.swalErrorAlert("Failed to place order. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     }, [cartState, deliveryMethod, deliveryAddress, priorityTip, couponCode]);

//     const memoizedCartContent = useMemo(() => {
//         // if (loading) {
//         //     return (
//         //         <Box display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
//         //             <CircularProgress />
//         //         </Box>
//         //     );
//         // }

//         if (error) {
//             return (
//                 <Box display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
//                     <Typography color="error">{error}</Typography>
//                 </Box>
//             );
//         }

//         if (cartState.cartData && cartState.cartData.length > 0) {
//             return (
//                 <>
//                     {/* Cart content JSX */}
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                         <Typography variant="h5">Your Cart</Typography>
//                         <Button onClick={() => { handleCartEmpty() }} startIcon={<ShoppingCartIcon />} color="inherit" variant="outlined" size="small">
//                             Empty Cart
//                         </Button>
//                     </Box>
//                     <Card sx={{ mb: 3 }}>
//                         <CardContent>
//                             <RadioGroup
//                                 value={deliveryMethod}
//                                 onChange={(e) => {
//                                     setDeliveryMethod(e.target.value)
//                                     handlePickup(e.target.value);
//                                 }}
//                                 row
//                             >
//                                 <FormControlLabel value="delivery" control={<StyledRadio />} label="Delivery" />
//                                 <FormControlLabel value="selfPickUp" control={<StyledRadio />} label="Self Pick Up" />
//                             </RadioGroup>

//                             {deliveryMethod === 'delivery' && (
//                                 <Box mt={2}>
//                                     <Typography variant="subtitle2" mb={1}>Delivery To</Typography>
//                                     <Select
//                                         fullWidth
//                                         value={deliveryAddress || ''}
//                                         onChange={(e) => {
//                                             console.log(e.target.value);
//                                             setDeliveryAddress(e.target.value);
//                                             handleAddress(e.target.value);
//                                         }}
//                                         displayEmpty
//                                         size="small"
//                                         sx={{ backgroundColor: 'white' }}
//                                         renderValue={(selected) => {
//                                             if (!selected) {
//                                                 return <em>Select an address</em>;
//                                             }
//                                             const selectedAddress = cartState?.AddressessList.find(address => address._id === selected);
//                                             return selectedAddress ? selectedAddress.label : '';
//                                         }}
//                                     >
//                                         <MenuItem value="" disabled>
//                                             <em>Select an address</em>
//                                         </MenuItem>
//                                         {cartState?.AddressessList && cartState?.AddressessList.map((address) => (
//                                             <MenuItem key={address._id} value={address._id}>
//                                                 {address.label}
//                                             </MenuItem>
//                                         ))}
//                                     </Select>
//                                     <>
//                                         <Box display="flex" alignItems="center" mb={1}>
//                                             <LocationOnIcon color="error" fontSize="small" sx={{ mr: 1 }} />
//                                             {cartState?.AddressessList && cartState?.AddressessList?.map((address) => (
//                                                 address._id === deliveryAddress &&
//                                                 <Typography variant="body2">{`${address?.location}, ${address?.block}, ${address?.unit}`}</Typography>
//                                             ))}
//                                         </Box>
//                                         <Box display="flex" alignItems="center">
//                                             <DirectionsBikeIcon color="error" fontSize="small" sx={{ mr: 1 }} />
//                                             <Typography variant="body2">
//                                                 Distance from you: {cartState?.DistanceFormula?.distance?.value ?
//                                                     `${parseFloat(cartState?.DistanceFormula?.distance?.value).toFixed(2) / 1000}km (${(cartState?.Calculations?.deliveryTipFee).toFixed(2)})` : ''}
//                                             </Typography>
//                                         </Box>
//                                         <Typography variant="caption" color="text.secondary">
//                                             incl. priority fee
//                                         </Typography>
//                                     </>
//                                 </Box>
//                             )}
//                         </CardContent>
//                     </Card>
//                     {deliveryMethod === 'delivery' &&
//                         <Card sx={{ mb: 3 }}>
//                             <CardContent>
//                                 <Typography variant="subtitle2" mb={1}>Prioritize Your Delivery</Typography>
//                                 <Typography variant="caption" color="text.secondary" display="block" mb={2}>
//                                     *Tip helps to prioritize your delivery
//                                 </Typography>
//                                 <Box display="flex" justifyContent="space-between">
//                                     {cartState?.Prioritizes?.map((tip) => (
//                                         <TipButton
//                                             key={tip}
//                                             variant={priorityTip === tip ? "contained" : "outlined"}
//                                             onClick={(e) => {
//                                                 handleTip(priorityTip === tip ? 0 : tip);
//                                                 setPriorityTip(priorityTip === tip ? 0 : tip)
//                                             }
//                                             }
//                                         >
//                                             {parseFloat(tip).toFixed(2)}
//                                         </TipButton>
//                                     ))}
//                                 </Box>
//                             </CardContent>
//                         </Card>
//                     }

//                     <Card sx={{ mb: 3 }}>
//                         <CardContent>
//                             <Typography variant="subtitle2" mb={1}>Discount Coupon</Typography>
//                             <Box display="flex">
//                                 <TextField
//                                     fullWidth
//                                     placeholder="Enter coupon code"
//                                     value={couponCode}
//                                     onChange={(e) => setCouponCode(e.target.value)}
//                                     variant="outlined"
//                                     size="small"
//                                     sx={{ backgroundColor: 'white' }}
//                                     InputProps={{
//                                         startAdornment: <LocalOfferIcon color="action" sx={{ mr: 1 }} />,
//                                     }}
//                                 />
//                                 <Button variant="contained" onClick={handleApplyCoupon} sx={{ ml: 1 }}>
//                                     Apply
//                                 </Button>
//                             </Box>
//                         </CardContent>
//                     </Card>

//                     <Card sx={{ mb: 3 }}>
//                         <CardContent>
//                             <Typography variant="subtitle1" mb={2}>Order Summary</Typography>
//                             {cartState?.cartData?.map((item) => (
//                                 <Box key={item._id} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                                     <Avatar src={item.product_details.Images[0]} sx={{ mr: 2 }} />
//                                     <Box flexGrow={1}>
//                                         <Typography variant="subtitle2">{item.product_details.item_name}</Typography>
//                                         <Typography variant="body2" color="text.secondary">{parseFloat(item.price).toFixed(2)}</Typography>
//                                     </Box>
//                                     <Box display="flex" alignItems="center">
//                                         <IconButton onClick={() => handleUpdateQuantity(item._id, parseInt(item.quantity) - 1)} size="small">
//                                             <RemoveIcon fontSize="small" />
//                                         </IconButton>
//                                         <Button
//                                             variant="contained"
//                                             color="primary"
//                                             size="small"
//                                             onClick={() => handleUpdateItem(item)}
//                                             sx={{ mx: 1 }}
//                                         >
//                                             Update {item.quantity}
//                                         </Button>
//                                         <IconButton onClick={() => handleUpdateQuantity(item._id, parseInt(item.quantity) + 1)} size="small">
//                                             <AddIcon fontSize="small" />
//                                         </IconButton>
//                                     </Box>

//                                     <IconButton onClick={() => handleRemoveItem(item)} size="small" sx={{ ml: 1 }}>
//                                         <CloseIcon fontSize="small" />
//                                     </IconButton>
//                                 </Box>
//                             ))}

//                             <Divider sx={{ my: 2 }} />
//                             <Box>
//                                 <Box display="flex" justifyContent="space-between" mb={1}>
//                                     <Typography>Subtotal</Typography>
//                                     <Typography>{parseFloat(cartState?.Calculations?.subTotal).toFixed(2)}</Typography>
//                                 </Box>
//                                 <Box display="flex" justifyContent="space-between" mb={1}>
//                                     <Typography>Discount</Typography>
//                                     <Typography>-{parseFloat(cartState?.Calculations?.discount).toFixed(2)}</Typography>
//                                 </Box>
//                                 <Box display="flex" justifyContent="space-between" mb={1}>
//                                     <Typography>{cartState?.Calculations?.sst_dynamic_label ? `${cartState?.Calculations?.sst_dynamic_label}(${cartState?.Calculations?.sst_percentage})` : 'SST'}</Typography>
//                                     <Typography>{parseFloat(cartState?.Calculations?.sst).toFixed(2)}</Typography>
//                                 </Box>
//                                 <Box display="flex" justifyContent="space-between" mb={1}>
//                                     <Typography>Delivery Fee & Tip</Typography>
//                                     <Typography>{parseFloat(cartState?.Calculations?.deliveryTipFee).toFixed(2)}</Typography>
//                                 </Box>
//                                 <Box display="flex" justifyContent="space-between" mt={2}>
//                                     <Typography variant="subtitle1">Total</Typography>
//                                     <Typography variant="subtitle1" color="primary">{parseFloat(cartState?.Calculations?.grandTotal).toFixed(2)}</Typography>
//                                 </Box>
//                             </Box>
//                         </CardContent>
//                     </Card>

//                     <Card sx={{ mb: 3 }}>
//                         <CardContent>
//                             <Typography variant="subtitle2" mb={1}>Payment Method</Typography>
//                             <Box display="flex" alignItems="center">
//                                 <AccountBalanceWalletIcon sx={{ mr: 2 }} />
//                                 <Typography>Balance: {cartState?.userBalance?.total_balance ? parseFloat(cartState?.userBalance?.total_balance).toFixed(2) : 0.00}</Typography>
//                             </Box>
//                         </CardContent>
//                     </Card>

//                     <Card sx={{ mb: 3 }}>
//                         <CardContent>
//                             <Typography variant="subtitle2" mb={1}>Branch</Typography>
//                             <Box display="flex" alignItems="center">
//                                 <StorefrontIcon sx={{ mr: 2 }} />
//                                 <Typography>{cartState?.cartData[0].business_details.name}</Typography>
//                             </Box>
//                         </CardContent>
//                     </Card>

//                     <Button
//                         variant="contained"
//                         fullWidth
//                         size="large"
//                         sx={{ py: 1.5, fontSize: '1.1rem' }}
//                         onClick={() => {
//                             handlePlaceOrder(cartState, deliveryMethod, deliveryAddress, priorityTip, couponCode, cartState?.Calculations.grandTotal);
//                             console.log("Place Order", { cartState, deliveryMethod, deliveryAddress, priorityTip, couponCode, total: cartState?.Calculations.grandTotal })
//                         }}
//                     >
//                         Place Order
//                     </Button>
//                 </>

//             );
//         }

//         return (
//             <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" flexGrow={1}>
//                 <Typography variant="h5" align="center" gutterBottom>Your Cart is Empty</Typography>
//                 <Typography variant="body1" align="center">
//                     Looks like you haven't added any items to your cart yet.
//                 </Typography>
//                 <Button
//                     variant="contained"
//                     fullWidth
//                     size="large"
//                     sx={{ mt: 3, py: 1.5, fontSize: '1.1rem', maxWidth: 300 }}
//                     onClick={() => { navigate('/CustomerHome') }}
//                 >
//                     Start Shopping
//                 </Button>
//             </Box>
//         );
//     }, [loading, error, cartState, navigate, couponCode, setCouponCode]);

//     return (
//         <ThemeProvider theme={theme}>
//             <Box sx={{ maxWidth: 600, margin: 'auto', padding: 3, backgroundColor: theme.palette.background.default, minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative' }}>
//                 {loading && (
//                     <LoaderOverlay>
//                         <CircularProgress />
//                     </LoaderOverlay>
//                 )}
//                 <Box sx={{ opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'auto' }}>
//                     {memoizedCartContent}
//                 </Box>
//             </Box>
//         </ThemeProvider>
//     );

// };

// export default React.memo(CartView);
